import Grid from "@/roc/grid/Grid";
class Rect {
    x;
    y;
    width;
    height;
    constructor(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    intersects(rect) {
        if (this.x + this.width <= rect.x ||
            rect.x + rect.width <= this.x ||
            this.y + this.height <= rect.y ||
            rect.y + rect.height <= this.y) {
            return false;
        }
        return true;
    }
    static toPixels(size) {
        return size * Grid.CELL_SIZE + 1;
    }
}
export default Rect;
